<template>
    <div class="comment">
        <div class="ajax comment__parent">
            <router-link :to="`/${$store.state.meta.lang}/user/${comment.username}`" class="global__image-outer-wrap global__image-outer-wrap--avatar-small">
                <div class="global__image-inner-wrap" 
                :style="comment.profile_photo_path?
					{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/'+ comment.profile_photo_path + ')' }:
					{ 'background-image': 'url(' + missed_avatar + ')' }"></div>
            </router-link>
            <div class="comment__summary">
                <div class="comment__author">
                    <router-link href="javascript:void(0)" v-b-toggle="'accordion-' + comment.id" to="">
                        <span class="when-opened">
                            <font-awesome-icon :icon="['fa','minus-square']" />
                        </span>
                        <span class="when-closed">
                            <font-awesome-icon :icon="['fa','plus-square']" />
                        </span>
                    </router-link>
                    <router-link :to="`/${$store.state.meta.lang}/user/${comment.username}`">{{comment.username}}</router-link>                    
                    <span class="ml-2 reply" @click="replyComment(comment.id)" :class='{"active" : selected}'>
                        <font-awesome-icon :icon="['fa','reply']" />
                    </span>
                    <span v-if="$store.state.username==comment.username" class="ml-1 remove" @click="confirmRemove(comment.id)">
                        <font-awesome-icon :icon="['fa','trash']" />
                    </span>
                    <span v-if="$store.state.username==comment.username" class="ml-1 edit" @click="editComment(comment.id, comment.content)">
                        <font-awesome-icon :icon="['fa','edit']" />
                    </span>
                </div>
                <!-- <b-collapse close class="comment__display-state" :id="'accordion-' + comment.id"> -->
                <b-collapse visible class="comment__display-state" :id="'accordion-' + comment.id">
                    <div class="comment__description markdown markdown--resize-body">
                        <p>{{comment.content}}</p>
                    </div>										
                    <div><span>{{comment.created_at | localTime | formatDate}}</span> {{ $t('gifts_ago') }} </div>
					<div class="comment__children">     
						<!-- >> -->
						<recursive-component v-for="(child, index) in comment.all_children" 
											:comment='child' 
											:key="index"
											@replyTo="replyMe($event)"
											>
						</recursive-component>
						<!-- << -->
					</div>
                </b-collapse>                
            </div>
        </div>        
    </div>    
</template>

<script>
	import {apiDomain} from '../config'

	export default {
		name: 'RecursiveComponent',
		props: {comment: Object},
		components: {  },
        data: function(){
			return {
				visible: false,
				selected: false,
				parentID: null,
				apiDomain : apiDomain,
                missed_avatar: require("./../assets/img/new-home/missed_avatar.jpg"),
            };  
        },
		methods: {
			replyComment: function(cid){
				/* --------------->  */
				var elems = document.querySelectorAll(".reply.active");
				[].forEach.call(elems, function(el) {
					el.classList.remove("active");
				});
				this.selected = !this.selected;
				/* <---------------  */
				cid = this.selected ? cid : 0;

				this.$emit('replyTo', {cid: cid, type: 'reply'})
			},
			replyMe: function(data){
				
				this.parentID = data.cid

				this.$emit('replyTo', data)
			},
			confirmRemove: function(cid){

				this.$swal({
					title: `${ this.$t('gifts_proceed') }`,
					text: `${ this.$t('gifts_no_revert') }`,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: `${ this.$t('gifts_yes') }`,
					cancelButtonText: `${ this.$t('gifts_no') }`,
					showCloseButton: true,
					showLoaderOnConfirm: true
				}).then((result) => {
					if(result.value) {
						this.$emit('replyTo', {cid: cid, type: 'remove'})
					} 
				})
			},
			editComment: function(cid, content){
				this.$emit('replyTo', {cid: cid, content: content, type: 'edit'});
			}
		},
		watch: {			
			'$store.state.meta.comments': function(){}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/scss/elementStyles.scss';
	@import '../assets/scss/variables.scss';
	@import '../assets/scss/idec.scss';

	.comments{
		.comment{
			margin: 1rem 0;
			border-bottom: 1px solid $color__gray--darker;

			&:last-child{
				border-bottom: none;
			}

			&__parent, &__child, &__entity{
				max-width: 850px;
				display: flex;
			}

			&__children{
				margin-left: 50px;
			}

			.global__image-outer-wrap--avatar-small{
				height: 32px;
				width: 32px;
			}

			&__child{
				border: 1px solid $color__lightgray--primary;
				border-radius: 4px;
				padding: 15px;
			}

			&__actions{
				display: flex;
			}

			.global__image-outer-wrap--avatar-small{
				margin-right: 10px;
			}

			&__children:not(.comment__children--no-indent){
				padding-left: 25px;
				border-left: 1px solid #d2d6e0;
			}

			.giveaway_image_avatar{
				margin-right: 1rem;
			}

			&__summary{
				padding-bottom: 0.5rem;
				
				.comment__author{
					color: $color__green--primary;
					margin-bottom: 5px;
					display: flex;

					svg{
						margin-top: -1px;
						margin-right: 0.5rem;

						&:focus, &:hover{
							cursor: pointer;
							outline: none;
						}
					}
				}
			}
			.nav__avatar-inner-wrap, .global__image-inner-wrap{
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 100%;
				width: 100%;
				border-radius: 2px;
			}
		}
	}

	.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;
						
			.threads_main__side_bar {
				display: none;
			}
			.threads_main__threads {
				width: 100%;
				margin-left: 0;
			}
		}
	}
</style>
<style>
.active{
	color: red;
}
</style>
